var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('select',{staticClass:"viewGantt",on:{"click":function($event){return _vm.valueClickedHandler()}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Please select one")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }